export default {
  namespaced: true,
  alarm: {
    alarm_id: "Alarm ID",
    description: "Description",
    title: "Alarm | Alarms",
    folioCAD: "Folio CAD",
    statusCAD: "Status CAD",
    reaction_patrol: "Reaction patrol",
    alarm_type: "Alarm type",
    status: "Status",
    attending: "Attending",
    attended: "Attended",
    waiting: "Waiting",
    canceled: "Canceled",
    all: "All",
    start_date_filter: "Start Datetime",
    end_date_filter: "End Datetime",
    date_filter: "Date Filter",
    dateRange: "Date range",
    dateRangeNone: "None",
    dateRangeLast30: "Last 30 days",
    dateRangeLast60: "Last 60 days",
    dateRangeHint: "Calculated from the moment the alarm view is opened",
    new_alarms: "New alarms",
    alarms: "Alarms",
    dispatch: "Dispatch",
    dispatchAlarm: "Dispatch alarm",
    alarmCreated: "Alarm triggered successfully",
    alarmError: "Alarm could not be triggered",
    noImagesInCarrousel: "No images available",
    loadingImage: "Loading image...",
    imageNotAvailable: "Image not available",
    comment: "Comment | Comments",
    type_alarm_not_found: "No alarm types found",
    created_by: "created by",
    timeline: {
      title: "Timeline",
      no_items: "No timeline items available.",
      analytic_record: "Analytic Record",
      comment: "Comment",
      detection_event: "Detection Event",
      command_log: "Command Log",
      action_plans_logs: "Action Plan Logs",
      alarm_bridge_device_logs: "Panel Events",
      users: "Users",
      unknown_command: "Unknown Command",
      camera: "Camera",
      server: "Server",
      category: "Category",
      alarm_type: "Alarm Type",
      priority: "Priority",
      matched_rules: "Matched Rules",
      record_info: "Record: {to} of {total} similar events",
      event_info: "Event: {to} of {total} similar detections",
      age: "Age",
      glasses: "Glasses",
      yes: "Yes",
      no: "No",
      list: "List",
      emotion: "Emotion",
      score: "Score",
      type: "Type",
      provider: "Provider",
      detection: "Detection",
      action: "Action",
      target: "Target",
      executed_by: "Executed by",
      executed_by_system: "Executed by System",
      user: "User",
      command_type: "Command Type",
      command: "Command",
      command_label: "Command Label",
      command_data: "Command Data",
      ai_prompt: "AI Prompt",
      ai_decision: "AI Decision",
      image: "Image",
      alarm_level: "Alarm Level",
      user_id: "User ID",
      delay_time: "Delay Time",
      dispatcher_info: "Dispatcher Info",
      dispatcher_id: "Dispatcher ID",
      source: "Source",
      workflow_id: "Workflow ID",
      camera_round: "Camera Round",
      name: "Name",
      cameras: "Cameras",
      users: "Users",
      location: "Location",
      loop: "Loop",
      radius: "Radius",
      layout: "Layout",
      dispatcher_name: "Dispatcher Name",
      alarm_id: "Alarm ID",
      description: "Description",
      action_plan: "Action Plan",
      action_plans_logs: "Action Plan Logs",
      instance: "Instance",
      plan_id: "Plan ID",
      duration: "Duration",
      step: "Step",
      steps: "Steps",
      decision: "Decision",
      node: "Node",
      terminate: "Terminate",
      partial_terminate: "Partial Terminate",
      question: "Question",
      answer: "Answer",
      answer_options: "Answer Options",
      required: "Required",
      executed: "Executed",
      continue: "Continue",
      outputs: "Outputs",
      data_types: "Data Types",
      filled_stack: "Filled Stack",
      reason: "Reason",
      started_at: "Started At",
      ended_at: "Ended At",
      command_data: "Command Data",
      instance_uuid: "Instance UUID",
      seq: "Sequence",
      files: "Files",
      comments: "Comments",
      cmd_id: "Command ID",
      cmd_name: "Command Name",
      created_at: "Created At",
      source_timestamp: "Source Timestamp",
      user_info: "User Information",
      email: "Email",
      command: "Command",
      information: "Information",
      full_name: "Name",
      soeid: "SOEID",
      alarm_workflow: 'Alarm Workflow',
      TAKEN: 'User taken the alarm',
      RELEASED: 'User released the alarm',
      SENT_TO_REVIEW: 'User sent the alarm to review',
      CHANGES_REQUESTED: 'Supervisor requested changes',
      SUPERVISOR_TAKEN_FROM_POOL: 'Supervisor taken an alarm from the list',
      OPERATOR_RESUMED_WORK: 'Operator open the alarm',
      COMPLETED: 'The alarm was marked as completed',
    },
    selected_alarms: "Selected alarms",
    filters: "Filters",
    type_alarm_categories: "Type alarm categories",
    type_alarm_categories_placeholder: "Select a category",
    select_options: "Select",
    remove_options: "Remove"
  },
};
